<template>
  <div class="v-dropdown-content" :class="cssClasses">
    <div class="v-dropdown-content__header">
      <div class="v-dropdown-content__backbutton" @click="toggle()">
        <v-icon icon="chevron-down" :ratio="0.5"></v-icon>
      </div>
      <span class="v-dropdown-content__headertitle">{{dropdownTitle}}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import VIcon from "../icon/Icon.vue";
export default {
  name: "v-dropdown-content",
  props: {
    variant: { type: String, default: "list" },
    columns: { type: Number, default: 1 },
    dropdownTitle: { type: String, default: "" }
  },
  methods: {
    toggle() {
      this.$parent.$emit("active");
    }
  },
  computed: {
    cssClasses() {
      let classes = [];
      classes.push("variant-" + this.variant);
      classes.push("columns-" + this.columns);
      return classes;
    }
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";
$nav-content-width: 250px;

.v-dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  background: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  z-index: 10;
  white-space: nowrap;
  overflow: hidden;
  .v-dropdown-content__header {
    display: none;
    background-color: #000000;
    color: #fff;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      a {
        cursor: pointer;
        color: #333;
      }
    }
  }

  &.variant-list {
    width: $nav-content-width;
    ul {
      li {
        border-bottom: 1px solid map-deep-get($colors, "ornament", "divider");
        a {
          display: block;
          padding: 15px 15px 15px 40px;
        }
        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }

  &.variant-columns {
    padding: 25px 40px 40px;

    ul {
      li {
        padding: 10px;
      }
    }
    &.columns-1 {
      width: $nav-content-width * 1;
      ul {
        columns: 1;
      }
    }
    &.columns-2 {
      width: $nav-content-width * 2;
      ul {
        columns: 2;
      }
    }
    &.columns-3 {
      width: $nav-content-width * 3;
      ul {
        columns: 3;
      }
    }
  }

  @media screen and (max-width: $grid-tablet-breakpoint) {
    width: initial !important;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    .v-dropdown-content__header {
      display: block;
      padding: 15px 20px 15px 20px;
      .v-dropdown-content__backbutton {
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        cursor: pointer;
        margin-left: 12px;

        .v-icon-chevron-down {
          transform: rotate(90deg) !important;
        }
      }

      .v-dropdown-content__headertitle {
        display: block;
        width: 100%;
        text-align: center;
      }
    }

    &.variant-columns {
      padding: 0;
      ul {
        width: 100%;
        li {
          border-bottom: 1px solid map-deep-get($colors, "ornament", "divider");
          padding: 13px 20px 13px;
          a {
            cursor: pointer;
            color: #333;
            width: 100%;
            display: block;
          }
        }
      }
      &.columns-1 {
        width: 100%;
        ul {
          columns: 1
        }
      }
      &.columns-2 {
        width: 100%;
        ul {
          columns: 1;
        }
      }
      &.columns-3 {
        width: 100%;
        ul {
          columns: 1;
        }
      }
    }
  }
}

.isOpen .v-dropdown-content {
  display: block;
}

.toggle-dropdown-enter-active {
  animation: toggle-dropdown 250ms;
}
.toggle-dropdown-leave-active {
  animation: toggle-dropdown 250ms reverse;
  transform: scaleY(0);
}
@keyframes toggle-dropdown {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}
</style>
